import icons from './index.vue';

var svgIcon = {
  install: function install(Vue) {
    Vue.component('svgIcon', icons);
  }
};

export default svgIcon;


//////////////////
// WEBPACK FOOTER
// ../vue-common-laboratory/src/components/icons/index.js
// module id = null
// module chunks = 